import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';

import { Horse_show_entry } from '../models/horse_show_entry';
import { AppSettings } from '../app.settings';

@Injectable({
  providedIn: 'root'
})
export class SearchHorseShowEntryService {

  constructor(private http: HttpClient) { }

  getByEntryNumber(horse_show_id: string, entry_number: number){
  	return this.getListWithRESTUrlFilter('horse_show_id/' + horse_show_id + '/entry_number/' + entry_number);
  }

  private getListWithRESTUrlFilter(rest_url: string): Promise<Horse_show_entry[]> {

		return new Promise((resolve, reject) => {

			return this.http.get(AppSettings.API_ENDPOINT + 'search_horse_show_entries/' + rest_url).subscribe((response:any) => {

		      if(response.type == 'horse_show_entries' && response.data){
		        resolve(response.data);
		      } else {
		        reject(response);
		      }

		    },
		      error => {
				if(error instanceof HttpErrorResponse){
            	  reject(error.error);
            	} else {
            		reject(error);
            	}
		      });
		  });
	 }

}
